// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_gE","seoBlockContent_visible":"c-a_gF"};